import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AutoComplete, Input, Select, Switch, } from 'antd';
import FormModal from 'components/FormModal';
import { txt } from 'libs/i18n';
import { filterOption } from 'libs/filterOption';
import styles from './style.module.less';
const defaultItem = { label: '', isDefault: false };
const createDefaultValues = (fields) => {
    const values = {};
    fields.forEach((field) => {
        values[field.key] = '';
    });
    return values;
};
const SelectWithActionsModal = ({ open, onClose, onConfirm, title, nameLabel, initialValue, fields, options, isSelectionStrict, }) => {
    var _a;
    const [item, setItem] = useState(defaultItem);
    const [fieldValues, setFieldValues] = useState({});
    const [showError, setShowError] = useState(false);
    useEffect(() => {
        if (open && initialValue !== undefined) {
            setItem(initialValue);
            if (fields !== undefined && fields.length > 0) {
                if (initialValue.values !== undefined) {
                    setFieldValues(initialValue.values);
                }
                else {
                    setFieldValues(createDefaultValues(fields));
                }
            }
        }
        else if (!open) {
            setItem(defaultItem);
            setShowError(false);
            if (fields !== undefined && fields.length > 0) {
                setFieldValues(createDefaultValues(fields));
            }
        }
    }, [open, initialValue, fields]);
    const isValid = () => {
        if (fields !== undefined && fields.length > 0) {
            return fields.some((field) => field.key in fieldValues && fieldValues[field.key].trim() !== '');
        }
        return item.label.trim() !== '';
    };
    const handleFieldChange = (key, value) => {
        setFieldValues((prev) => (Object.assign(Object.assign({}, prev), { [key]: value })));
    };
    const handleSubmit = () => {
        if (!isValid()) {
            setShowError(true);
            return;
        }
        onConfirm(item.label, item.isDefault, fieldValues);
        onClose();
    };
    const handleCancel = () => {
        setItem(defaultItem);
        setShowError(false);
        if (fields !== undefined && fields.length > 0) {
            setFieldValues(createDefaultValues(fields));
        }
        onClose();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleSubmit();
        }
    };
    const renderFields = () => {
        if (fields !== undefined && fields.length > 0) {
            return (_jsx(_Fragment, { children: fields.map((field, index) => (_jsxs("div", { className: styles.field, children: [_jsx("label", { htmlFor: `field-${field.key}`, children: field.label }), _jsx(Input, { id: `field-${field.key}`, autoFocus: index === 0, value: fieldValues[field.key] || '', onChange: (e) => handleFieldChange(field.key, e.target.value), onKeyDown: handleKeyDown })] }, field.key))) }));
        }
        return (_jsxs("div", { className: styles.field, children: [_jsx("label", { htmlFor: "itemName", children: nameLabel }), isSelectionStrict ? (_jsx(Select, { showSearch: true, filterOption: filterOption, options: options })) : (_jsx(AutoComplete, { id: "itemName", autoFocus: true, value: item.label, onChange: (value) => setItem((prev) => (Object.assign(Object.assign({}, prev), { label: value }))), onKeyDown: handleKeyDown, options: options, filterOption: filterOption }))] }));
    };
    const isError = showError && !isValid();
    return (_jsxs(FormModal, { title: title, open: open, onCancel: handleCancel, onOk: handleSubmit, okText: txt('save'), cancelText: txt('cancel'), getContainer: document.body, children: [renderFields(), isError && _jsx("span", { className: styles.fieldError, children: ((_a = fields === null || fields === void 0 ? void 0 : fields.length) !== null && _a !== void 0 ? _a : 0) >= 1 ? txt('addAtLeastOne') : txt('fieldIsRequired') }), _jsxs("div", { className: styles.switchField, children: [_jsx("label", { htmlFor: "setAsDefault", children: txt('setAsDefault') }), _jsx(Switch, { size: "small", id: "setAsDefault", checked: item.isDefault, onChange: (checked) => setItem((prev) => (Object.assign(Object.assign({}, prev), { isDefault: checked }))) })] })] }));
};
export default SelectWithActionsModal;
